export const THEMES = [
  {
    key:     'navy',
    label:   'Navy',
    preview: '#0D1E35',

    vars: {
      '--primary':        '#2563EB',
      '--primary-dark':   '#1A4FBF',
      '--primary-light':  '#0D2248',
      '--accent':         '#38BDF8',
      '--success':        '#10B981',
      '--warning':        '#F59E0B',
      '--danger':         '#EF4444',
      '--info':           '#38BDF8',

      '--bg':             '#071325',
      '--surface':        '#0D1E35',
      '--surface-alt':    '#0A1628',
      '--border':         '#1A2E4A',
      '--border-dark':    '#243C5E',
      '--hover':          'rgba(37,99,235,0.10)',

      '--text':           '#E8F0F8',
      '--text-muted':     '#7A9EC0',
      '--text-light':     '#4A6A90',

      '--nav-bg':           '#040E1C',
      '--nav-text':         '#A0BDD8',
      '--nav-icon-size':    '14px',
      '--nav-link-opacity': '0.72',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.5)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.6)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.7)',

      '--table-header-bg':      '#0A1A30',
      '--table-row-alt-bg':     '#091628',
      '--table-footer-bg':      '#0A1A30',
      '--group-header-bg':      '#0A1628',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#2563EB',
      '--active-text':          '#FFFFFF',
      '--badge-active-bg':      'rgba(37,99,235,0.15)',
      '--badge-active-color':   '#93C5FD',
      '--badge-active-dot':     '#2563EB',
      '--badge-inactive-bg':    'rgba(239,68,68,0.10)',
      '--badge-inactive-color': '#FCA5A5',
      '--badge-inactive-dot':   '#EF4444',
      '--hover-danger-bg':      '#1A0A0A',
      '--image-viewer-bg':      '#030A14',
      '--primary-muted':        'rgba(37,99,235,0.22)',
      '--banner-bg':            '#2563EB',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  {
    key:     'dark-mono',
    label:   'Dark',
    preview: '#161616',

    vars: {
      '--primary':        '#FFFFFF',
      '--primary-dark':   '#E0E0E0',
      '--primary-light':  '#222222',
      '--accent':         '#AAAAAA',
      '--success':        '#888888',
      '--warning':        '#707070',
      '--danger':         '#CCCCCC',
      '--info':           '#999999',

      '--bg':             '#0C0C0C',
      '--surface':        '#161616',
      '--surface-alt':    '#1E1E1E',
      '--border':         '#2C2C2C',
      '--border-dark':    '#3C3C3C',
      '--hover':          'rgba(255,255,255,0.05)',

      '--text':           '#F0F0F0',
      '--text-muted':     '#888888',
      '--text-light':     '#555555',

      '--nav-bg':           '#000000',
      '--nav-text':         '#AAAAAA',
      '--nav-icon-size':    '14px',
      '--nav-link-opacity': '0.72',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.5)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.6)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.7)',

      '--table-header-bg':      '#1A1A1A',
      '--table-row-alt-bg':     '#1C1C1C',
      '--table-footer-bg':      '#1A1A1A',
      '--group-header-bg':      '#1E1E1E',
      '--btn-primary-text':     '#000000',
      '--active-bg':            '#FFFFFF',
      '--active-text':          '#000000',
      '--badge-active-bg':      'rgba(255,255,255,0.09)',
      '--badge-active-color':   '#DDDDDD',
      '--badge-active-dot':     '#FFFFFF',
      '--badge-inactive-bg':    'rgba(255,255,255,0.06)',
      '--badge-inactive-color': '#888888',
      '--badge-inactive-dot':   '#888888',
      '--hover-danger-bg':      '#2A2020',
      '--image-viewer-bg':      '#0A0A0A',
      '--primary-muted':        'rgba(255,255,255,0.08)',
      '--banner-bg':            '#2563EB',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  {
    key:     'light-color',
    label:   'Light',
    preview: '#F4F6FB',

    vars: {
      '--primary':        '#0057FF',
      '--primary-dark':   '#003FBF',
      '--primary-light':  '#E8F0FF',
      '--accent':         '#FF6B35',
      '--success':        '#10B981',
      '--warning':        '#F59E0B',
      '--danger':         '#EF4444',
      '--info':           '#3B82F6',

      '--bg':             '#F4F6FB',
      '--surface':        '#FFFFFF',
      '--surface-alt':    '#F9FAFB',
      '--border':         '#E2E8F0',
      '--border-dark':    '#CBD5E1',
      '--hover':          'rgba(0,0,0,0.04)',

      '--text':           '#1A202C',
      '--text-muted':     '#64748B',
      '--text-light':     '#94A3B8',

      '--nav-bg':           '#FFFFFF',
      '--nav-text':         '#1A202C',
      '--nav-icon-size':    '14px',
      '--nav-link-opacity': '0.80',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.08)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.12)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.16)',

      '--table-header-bg':      '#F1F5FB',
      '--table-row-alt-bg':     '#FAFBFD',
      '--table-footer-bg':      '#F8FAFC',
      '--group-header-bg':      '#F1F5F9',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#0057FF',
      '--active-text':          '#FFFFFF',
      '--badge-active-bg':      'rgba(16,185,129,0.08)',
      '--badge-active-color':   '#059669',
      '--badge-active-dot':     '#10B981',
      '--badge-inactive-bg':    'rgba(239,68,68,0.08)',
      '--badge-inactive-color': '#DC2626',
      '--badge-inactive-dot':   '#EF4444',
      '--hover-danger-bg':      '#FEF2F2',
      '--image-viewer-bg':      '#111111',
      '--primary-muted':        'rgba(0,87,255,0.08)',
      '--banner-bg':            '#0057FF',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  {
    key:     'ocean-blue',
    label:   'Ocean',
    preview: '#0C1A2E',

    vars: {
      '--primary':        '#4A9EFF',
      '--primary-dark':   '#2A7EDF',
      '--primary-light':  '#0E2A4A',
      '--accent':         '#FF6B6B',
      '--success':        '#4ACF8A',
      '--warning':        '#F0A040',
      '--danger':         '#FF6B6B',
      '--info':           '#7AA8D4',

      '--bg':             '#060D1A',
      '--surface':        '#0C1A2E',
      '--surface-alt':    '#0A1828',
      '--border':         '#1A3050',
      '--border-dark':    '#243C60',
      '--hover':          'rgba(74,158,255,0.07)',

      '--text':           '#C8DCF0',
      '--text-muted':     '#7AA8D4',
      '--text-light':     '#4A7AAA',

      '--nav-bg':           '#030810',
      '--nav-text':         '#7AA8D4',
      '--nav-icon-size':    '14px',
      '--nav-link-opacity': '0.72',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.5)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.6)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.7)',

      '--table-header-bg':      '#0E2240',
      '--table-row-alt-bg':     '#0A1E38',
      '--table-footer-bg':      '#0E2240',
      '--group-header-bg':      '#0A1828',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#1A6FC4',
      '--active-text':          '#FFFFFF',
      '--badge-active-bg':      'rgba(74,158,255,0.12)',
      '--badge-active-color':   '#7AC8FF',
      '--badge-active-dot':     '#4A9EFF',
      '--badge-inactive-bg':    'rgba(255,107,107,0.10)',
      '--badge-inactive-color': '#FF8E8E',
      '--badge-inactive-dot':   '#FF6B6B',
      '--hover-danger-bg':      '#2A1010',
      '--image-viewer-bg':      '#040810',
      '--primary-muted':        'rgba(74,158,255,0.20)',
      '--banner-bg':            '#1A6FC4',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },
  {
    key:     'high-contrast',
    label:   'High Contrast',
    preview: '#0F172A',

    vars: {
      '--primary':        '#38BDF8',
      '--primary-dark':   '#0EA5E9',
      '--primary-light':  '#0C2340',
      '--accent':         '#FB923C',
      '--success':        '#4ADE80',
      '--warning':        '#FBBF24',
      '--danger':         '#F87171',
      '--info':           '#38BDF8',

      '--bg':             '#0A0F1E',
      '--surface':        '#111827',
      '--surface-alt':    '#0F172A',
      '--border':         '#1E2D45',
      '--border-dark':    '#2D4060',
      '--hover':          'rgba(56,189,248,0.10)',

      '--text':           '#F8FAFC',
      '--text-muted':     '#94A3B8',
      '--text-light':     '#64748B',

      '--nav-bg':         '#0F172A',
      '--nav-text':       '#F1F5F9',
      '--nav-icon-size':  '18px',
      '--nav-link-opacity': '1',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.5)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.6)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.7)',

      '--table-header-bg':      '#0F1E35',
      '--table-row-alt-bg':     '#0C1828',
      '--table-footer-bg':      '#0F1E35',
      '--group-header-bg':      '#0F172A',
      '--btn-primary-text':     '#000000',
      '--active-bg':            '#38BDF8',
      '--active-text':          '#000000',
      '--badge-active-bg':      'rgba(74,222,128,0.12)',
      '--badge-active-color':   '#4ADE80',
      '--badge-active-dot':     '#4ADE80',
      '--badge-inactive-bg':    'rgba(248,113,113,0.12)',
      '--badge-inactive-color': '#F87171',
      '--badge-inactive-dot':   '#F87171',
      '--hover-danger-bg':      '#2A1010',
      '--image-viewer-bg':      '#050A10',
      '--primary-muted':        'rgba(56,189,248,0.20)',
      '--banner-bg':            '#38BDF8',
      '--banner-text':          '#000000',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  {
    key:     'violet-light',
    label:   'Violet',
    preview: '#7C3AED',

    vars: {
      '--primary':        '#7C3AED',
      '--primary-dark':   '#5B21B6',
      '--primary-light':  '#EDE9FE',
      '--accent':         '#F97316',
      '--success':        '#10B981',
      '--warning':        '#F59E0B',
      '--danger':         '#EF4444',
      '--info':           '#7C3AED',

      '--bg':             '#F3F4F6',
      '--surface':        '#FFFFFF',
      '--surface-alt':    '#F9FAFB',
      '--border':         '#E5E7EB',
      '--border-dark':    '#D1D5DB',
      '--hover':          'rgba(124,58,237,0.07)',

      '--text':           '#111827',
      '--text-muted':     '#6B7280',
      '--text-light':     '#9CA3AF',

      '--nav-bg':             '#7C3AED',
      '--nav-text':           '#FFFFFF',
      '--nav-active-text':    '#FFFFFF',
      '--sidebar-active-bg':  'rgba(255,255,255,0.18)',
      '--nav-border':         'rgba(255,255,255,0.22)',
      '--nav-btn-hover':      'rgba(255,255,255,0.14)',
      '--nav-icon-size':      '18px',
      '--nav-link-opacity':   '1',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.08)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.12)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.18)',

      '--table-header-bg':      '#F9FAFB',
      '--table-row-alt-bg':     '#F3F4F6',
      '--table-footer-bg':      '#F9FAFB',
      '--group-header-bg':      '#F3F4F6',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#EDE9FE',
      '--active-text':          '#5B21B6',
      '--badge-active-bg':      'rgba(16,185,129,0.08)',
      '--badge-active-color':   '#059669',
      '--badge-active-dot':     '#10B981',
      '--badge-inactive-bg':    'rgba(239,68,68,0.08)',
      '--badge-inactive-color': '#DC2626',
      '--badge-inactive-dot':   '#EF4444',
      '--hover-danger-bg':      '#FEF2F2',
      '--image-viewer-bg':      '#0A0414',
      '--primary-muted':        'rgba(124,58,237,0.10)',
      '--banner-bg':            '#7C3AED',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  // ── Hybrid dark-sidebar + light-content themes ──────────────────────────

  {
    key:     'indigo-cream',
    label:   'Indigo',
    preview: '#1E1B4B',

    vars: {
      '--primary':        '#7C3AED',
      '--primary-dark':   '#5B21B6',
      '--primary-light':  '#EDE9FE',
      '--accent':         '#F59E0B',
      '--success':        '#10B981',
      '--warning':        '#F59E0B',
      '--danger':         '#EF4444',
      '--info':           '#7C3AED',

      '--bg':             '#F5F3FF',
      '--surface':        '#FFFFFF',
      '--surface-alt':    '#FAFAFA',
      '--border':         '#E5E7EB',
      '--border-dark':    '#D1D5DB',
      '--hover':          'rgba(124,58,237,0.06)',

      '--text':           '#1E1B4B',
      '--text-muted':     '#6B7280',
      '--text-light':     '#9CA3AF',

      '--nav-bg':           '#1E1B4B',
      '--nav-text':         '#E0D7FF',
      '--nav-icon-size':    '18px',
      '--nav-link-opacity': '1',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.08)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.12)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.18)',

      '--table-header-bg':      '#F3F4F6',
      '--table-row-alt-bg':     '#FAFAFA',
      '--table-footer-bg':      '#F3F4F6',
      '--group-header-bg':      '#F9FAFB',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#7C3AED',
      '--active-text':          '#FFFFFF',
      '--badge-active-bg':      'rgba(16,185,129,0.08)',
      '--badge-active-color':   '#059669',
      '--badge-active-dot':     '#10B981',
      '--badge-inactive-bg':    'rgba(239,68,68,0.08)',
      '--badge-inactive-color': '#DC2626',
      '--badge-inactive-dot':   '#EF4444',
      '--hover-danger-bg':      '#FEF2F2',
      '--image-viewer-bg':      '#080412',
      '--primary-muted':        'rgba(124,58,237,0.10)',
      '--banner-bg':            '#7C3AED',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  {
    key:     'slate-pearl',
    label:   'Slate',
    preview: '#0F172A',

    vars: {
      '--primary':        '#0EA5E9',
      '--primary-dark':   '#0284C7',
      '--primary-light':  '#E0F2FE',
      '--accent':         '#EC4899',
      '--success':        '#10B981',
      '--warning':        '#F59E0B',
      '--danger':         '#EF4444',
      '--info':           '#0EA5E9',

      '--bg':             '#F8FAFC',
      '--surface':        '#FFFFFF',
      '--surface-alt':    '#F1F5F9',
      '--border':         '#E2E8F0',
      '--border-dark':    '#CBD5E1',
      '--hover':          'rgba(14,165,233,0.06)',

      '--text':           '#0F172A',
      '--text-muted':     '#64748B',
      '--text-light':     '#94A3B8',

      '--nav-bg':           '#0F172A',
      '--nav-text':         '#E2E8F0',
      '--nav-icon-size':    '18px',
      '--nav-link-opacity': '1',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.08)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.12)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.18)',

      '--table-header-bg':      '#F1F5F9',
      '--table-row-alt-bg':     '#F8FAFC',
      '--table-footer-bg':      '#F1F5F9',
      '--group-header-bg':      '#F8FAFC',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#0EA5E9',
      '--active-text':          '#FFFFFF',
      '--badge-active-bg':      'rgba(16,185,129,0.08)',
      '--badge-active-color':   '#059669',
      '--badge-active-dot':     '#10B981',
      '--badge-inactive-bg':    'rgba(239,68,68,0.08)',
      '--badge-inactive-color': '#DC2626',
      '--badge-inactive-dot':   '#EF4444',
      '--hover-danger-bg':      '#FEF2F2',
      '--image-viewer-bg':      '#020B18',
      '--primary-muted':        'rgba(14,165,233,0.10)',
      '--banner-bg':            '#0EA5E9',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  {
    key:     'forest-ivory',
    label:   'Forest',
    preview: '#052E16',

    vars: {
      '--primary':        '#059669',
      '--primary-dark':   '#047857',
      '--primary-light':  '#D1FAE5',
      '--accent':         '#F97316',
      '--success':        '#10B981',
      '--warning':        '#F59E0B',
      '--danger':         '#EF4444',
      '--info':           '#059669',

      '--bg':             '#F6FBF7',
      '--surface':        '#FFFDF7',
      '--surface-alt':    '#F0FAF4',
      '--border':         '#D1FAE5',
      '--border-dark':    '#A7F3D0',
      '--hover':          'rgba(5,150,105,0.06)',

      '--text':           '#052E16',
      '--text-muted':     '#6B7280',
      '--text-light':     '#9CA3AF',

      '--nav-bg':           '#052E16',
      '--nav-text':         '#D1FAE5',
      '--nav-icon-size':    '18px',
      '--nav-link-opacity': '1',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.08)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.12)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.18)',

      '--table-header-bg':      '#ECFDF5',
      '--table-row-alt-bg':     '#F6FBF7',
      '--table-footer-bg':      '#ECFDF5',
      '--group-header-bg':      '#F0FDF4',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#059669',
      '--active-text':          '#FFFFFF',
      '--badge-active-bg':      'rgba(16,185,129,0.10)',
      '--badge-active-color':   '#047857',
      '--badge-active-dot':     '#10B981',
      '--badge-inactive-bg':    'rgba(239,68,68,0.08)',
      '--badge-inactive-color': '#DC2626',
      '--badge-inactive-dot':   '#EF4444',
      '--hover-danger-bg':      '#FEF2F2',
      '--image-viewer-bg':      '#010A04',
      '--primary-muted':        'rgba(5,150,105,0.10)',
      '--banner-bg':            '#059669',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },

  {
    key:     'crimson-snow',
    label:   'Crimson',
    preview: '#1C0A0A',

    vars: {
      '--primary':        '#DC2626',
      '--primary-dark':   '#B91C1C',
      '--primary-light':  '#FEE2E2',
      '--accent':         '#7C3AED',
      '--success':        '#10B981',
      '--warning':        '#F59E0B',
      '--danger':         '#EF4444',
      '--info':           '#DC2626',

      '--bg':             '#FFF8F8',
      '--surface':        '#FFFFFF',
      '--surface-alt':    '#FEF2F2',
      '--border':         '#FEE2E2',
      '--border-dark':    '#FECACA',
      '--hover':          'rgba(220,38,38,0.05)',

      '--text':           '#1C0A0A',
      '--text-muted':     '#6B7280',
      '--text-light':     '#9CA3AF',

      '--nav-bg':           '#1C0A0A',
      '--nav-text':         '#FEE2E2',
      '--nav-icon-size':    '18px',
      '--nav-link-opacity': '1',

      '--radius':         '12px',
      '--radius-sm':      '8px',
      '--radius-lg':      '16px',
      '--shadow':         '0 2px 12px rgba(0,0,0,0.08)',
      '--shadow-md':      '0 4px 24px rgba(0,0,0,0.12)',
      '--shadow-lg':      '0 8px 40px rgba(0,0,0,0.18)',

      '--table-header-bg':      '#FEF2F2',
      '--table-row-alt-bg':     '#FFF8F8',
      '--table-footer-bg':      '#FEF2F2',
      '--group-header-bg':      '#FFF5F5',
      '--btn-primary-text':     '#FFFFFF',
      '--active-bg':            '#DC2626',
      '--active-text':          '#FFFFFF',
      '--badge-active-bg':      'rgba(16,185,129,0.08)',
      '--badge-active-color':   '#059669',
      '--badge-active-dot':     '#10B981',
      '--badge-inactive-bg':    'rgba(220,38,38,0.10)',
      '--badge-inactive-color': '#B91C1C',
      '--badge-inactive-dot':   '#DC2626',
      '--hover-danger-bg':      '#FEE2E2',
      '--image-viewer-bg':      '#0A0202',
      '--primary-muted':        'rgba(220,38,38,0.10)',
      '--banner-bg':            '#DC2626',
      '--banner-text':          '#FFFFFF',

      '--card-padding':         '28px',
      '--form-gap':             '20px',
      '--input-padding':        '10px 14px',
      '--detail-page-padding':  '24px 20px',
    },
  },
];

export const DEFAULT_THEME_KEY = 'light-color';
